<div>
  <ejs-grid class="e-grid" #grid [dataSource]='gridList' height="100%" [allowSorting]='true'
      [allowFiltering]='true' [filterSettings]='filterSettings' [toolbar]='toolbar' [allowPaging]="true"
      [pageSettings]='pageSettings'>
      <e-columns>
          <ng-container *ngFor="let column of ColumnData">
              <e-column *ngIf='(column.field !== "action" && column.field !== "status")' [field]="column.field"
                  [headerText]="column.headerText" [textAlign]="column.text_align" [width]="column.width"
                  [minWidth]='column.minWidth'>
              </e-column>
              <e-column *ngIf='column.field === "status"' [field]="column.field" [headerText]="column.headerText"
                  [textAlign]="column.text_align" [width]="column.width" [minWidth]="column.minWidth">
                  <ng-template #template let-data>
                      <span>{{ data.status === 1 ? 'Active' : 'Inactive' }}</span>
                  </ng-template>
              </e-column>
              <e-column *ngIf='column.field === "action"' [textAlign]="column.text_align" [allowFiltering]='false'
                  [field]="column.field" [headerText]="column.headerText" [width]="column.width"
                  [minWidth]='column.minWidth'>
                  <ng-template #template let-data>
                      <button 
                          class="cls-blue" 
                          *ngIf="abacService.verifyAccess('Update')" 
                          (click)="onEditStatus(data)">
                          <i class="fas fa-edit"></i> 
                      </button>
                      <button 
                          class="cls-red space-bet" 
                          *ngIf="abacService.verifyAccess('Delete')" 
                          (click)="onDeleteStatus(data)">
                          <i class="fas fa-trash-alt"></i> 
                      </button>
                  </ng-template>
              </e-column>
          </ng-container>
      </e-columns>
  </ejs-grid>
</div>

